import { Swiper } from 'swiper';
import { A11y, Navigation } from 'swiper/modules';
import { Fancybox } from '@fancyapps/ui';

class ProductMedia extends HTMLElement {
  constructor() {
    super();
    this.swiper();
    this.fancybox();
  }

  swiper() {
    // Get swiper element
    this.swiperElement = this.querySelector('[data-product-media-swiper]');

    // Init swiper
    this.swiperInstance = new Swiper(this.swiperElement, {
      modules: [A11y, Navigation],
      threshold: 10,
      direction: 'horizontal',
    });

    // Rebuid Swiper in design mode
    if (Shopify.designMode && this.swiperInstance) {
      window.addEventListener('shopify:section:load', () => this.swiperInstance.update());
    }
  }

  /*
   * Create fancybox
   */
  fancybox() {
    Fancybox.bind('[data-fancybox]', {
      animated: false,
      showClass: false,
      mainClass: 'image-zoom',
    });
  }
}

customElements.define('product-media', ProductMedia);
